import React from "react";
import GoogleMapReact from "google-map-react";
import "./styles.css";
import MyMarker from "./MyMarker";

function createMapOptions(maps) {
  // next props are exposed at maps
  // "Animation", "ControlPosition", "MapTypeControlStyle", "MapTypeId",
  // "NavigationControlStyle", "ScaleControlStyle", "StrokePosition", "SymbolPath", "ZoomControlStyle",
  // "DirectionsStatus", "DirectionsTravelMode", "DirectionsUnitSystem", "DistanceMatrixStatus",
  // "DistanceMatrixElementStatus", "ElevationStatus", "GeocoderLocationType", "GeocoderStatus", "KmlLayerStatus",
  // "MaxZoomStatus", "StreetViewStatus", "TransitMode", "TransitRoutePreference", "TravelMode", "UnitSystem"
  return {
    fullscreenControl: false,
    zoomControl: false,
    styles: [
      {
        stylers: [
          {
            invert_lightness: true,
          },
          {
            saturation: 10,
          },
          {
            lightness: 30,
          },
          {
            gamma: 0.5,
          },
          {
            hue: "#104d82",
          },
        ],
      },
    ],
  };
}

export default function Map({
  locations,
  zoomLevel,
  disableHover,
  region,
  center,
}) {
  const distanceToMouse = (pt, mp) => {
    if (pt && mp) {
      // return distance between the marker and mouse pointer
      return Math.sqrt(
        (pt.x - mp.x) * (pt.x - mp.x) + (pt.y - mp.y) * (pt.y - mp.y)
      );
    }
  };

  return (
    <div className="map">
      <div className="google-map">
        <GoogleMapReact
          bootstrapURLKeys={{
            key: "AIzaSyAAAj1P59p4tswF_Xdv7-aMr9ybbpr1aWg",
            region: region || "",
          }}
          center={center}
          defaultZoom={2}
          zoom={zoomLevel}
          disabled
          yesIWantToUseGoogleMapApiInternals={true}
          distanceToMouse={distanceToMouse}
          options={createMapOptions}
        >
          {locations
            .filter((location) => location.lng !== 0 && location.lat !== 0)
            .map((location, index) => {
              return (
                <MyMarker
                  location={location}
                  key={index}
                  lng={location.lng}
                  lat={location.lat}
                  disableHover={disableHover}
                />
              );
            })}
        </GoogleMapReact>
      </div>
    </div>
  );
}
